import { FC, HTMLAttributes } from 'react';

type BybitWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const BybitWallet: FC<BybitWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 88 88"
      {...props}
    >
      <path
        fill="#404347"
        d="M0 18.7C0 8.372 8.372 0 18.7 0h50.6C79.628 0 88 8.372 88 18.7v50.6C88 79.628 79.628 88 69.3 88H18.7C8.372 88 0 79.628 0 69.3z"
      ></path>
      <path
        fill="url(#paint0_linear_312_17534)"
        d="M7.576 26.807a4.89 4.89 0 0 1 3.68-6.144l46.353-9.846a4.89 4.89 0 0 1 5.416 2.652l20.82 42.997L25.177 87.51z"
      ></path>
      <path
        fill="#fff"
        d="M8.182 30.162a4.89 4.89 0 0 1 4.068-6.206l61.436-7.968a4.89 4.89 0 0 1 5.425 3.899l8.89 44.89-63.312 22.49z"
      ></path>
      <path
        fill="#000"
        d="M0 34.222c0-5.4 4.378-9.777 9.778-9.777h58.666C79.244 24.445 88 33.2 88 44v24.445C88 79.245 79.245 88 68.444 88H19.556C8.756 88 0 79.245 0 68.445z"
      ></path>
      <path fill="#F7A600" d="M58.22 61.196v-18.32h3.574v18.32z"></path>
      <path
        fill="#fff"
        d="M17.44 66.664H9.778v-18.32h7.353c3.574 0 5.656 2.006 5.656 5.145 0 2.033-1.337 3.346-2.261 3.783 1.105.515 2.52 1.672 2.52 4.117 0 3.422-2.341 5.275-5.607 5.275m-.592-15.13h-3.496v4.22h3.496c1.516 0 2.366-.848 2.366-2.108 0-1.263-.848-2.112-2.366-2.112m.231 7.437h-3.727v4.502h3.727c1.62 0 2.391-1.03 2.391-2.264.002-1.236-.77-2.238-2.39-2.238M32.893 59.15v7.514h-3.55V59.15l-5.501-10.807h3.882l3.42 7.385 3.367-7.385h3.882zM48.563 66.664h-7.661v-18.32h7.353c3.574 0 5.656 2.006 5.656 5.145 0 2.033-1.337 3.346-2.261 3.783 1.105.515 2.52 1.672 2.52 4.117-.003 3.422-2.343 5.275-5.607 5.275m-.591-15.13h-3.497v4.22h3.497c1.516 0 2.366-.848 2.366-2.108-.002-1.263-.85-2.112-2.366-2.112m.231 7.437h-3.728v4.502h3.728c1.62 0 2.39-1.03 2.39-2.264 0-1.236-.772-2.238-2.39-2.238M73.439 51.534v15.13h-3.574v-15.13h-4.781v-3.19h13.138v3.19z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_312_17534"
          x1="7.333"
          x2="84.638"
          y1="25.594"
          y2="21.722"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD748"></stop>
          <stop offset="1" stopColor="#F7A600"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BybitWallet;
